import { Component } from "@angular/core";
import {
	NavController,
	NavParams,
	ViewController,
	App,
	Platform,
	Events
} from "ionic-angular";


import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";

@Component({
	selector: "modal-inventory-breakup",
	templateUrl: "./modal-inventory-breakup.html"
})
export class InventoryBreakupModalPage {
	requestIndex: any = null;
	technical_name:any= null;
	public inventories: any = [];

	total_quantity:any =null;

	product_id:any=null;
	pending_allocation:any=null;


	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public platform: Platform,
		public app: App,
		public events: Events,
		public helperService: HelperServiceProvider,
		public apiService: APIServiceProvider,
		public navParams: NavParams
		) {
		this.requestIndex = navParams.get("index");


	}

	dismiss() {
		this.viewCtrl.dismiss();
	}

	ionViewDidLoad() {
		this.product_id = this.navParams.get("product_id");
		console.log(this.product_id);

		this.handelBackButton();
		this.getInventoryBreakup();
	}

	handelBackButton() {}

	getInventoryBreakup(){
		let url = 'products/get-quantity-breakup';
		this.apiService.post(
			"products/get-quantity-breakup",
			{product_id:this.product_id}
			).subscribe(response => {
				this.inventories = response["data"]["quantity_breakup"];
				this.total_quantity = response["data"]["total_quantity"];
				this.pending_allocation = response["data"]["pending_allocation"];


				console.log(this.inventories);
			}, err => {
				console.log(err);
			})
		}




	}




// WEBPACK FOOTER //
// ./src/modals/inventory-breakup/inventory-breakup.modal.ts